import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import moment from 'angular-moment';

import routing from './daily_group_report.routes';
import GroupActivePowerService from '../../../components/api/group_active_power/group_active_power.service';
import Chart from '../../../components/directive/chart/chart.directive';
import DateUtil from '../../../components/logic/date_util/date_util.module';
import CsvUtil from '../../../components/logic/csv_util/csv.util';
import MathUtil from '../../../components/logic/math_util/math_util';
import GroupReportUtil from '../../../components/logic/group_report/group_report_util.service';
import chartConfig from './daily_group_report.config';

export class DailyGroupReportController {
  /*@ngInject*/
  constructor($stateParams, $filter, $interval, moment, GroupActivePowerService, DateUtil, CsvUtil, MathUtil, GroupReportUtil) {
    this.id = $stateParams.id;
    this.$filter = $filter;
    this.interval = $interval;
    this.GroupActivePowerService = GroupActivePowerService;
    this.DateUtil = DateUtil;
    this.moment = moment;
    this.CsvUtil = CsvUtil;
    this.MathUtil = MathUtil;
    this.GroupReportUtil = GroupReportUtil;

    this.categories = DateUtil.getXLabels;
    this.today = this.moment().startOf('day').toDate();
    this.targetDate = $stateParams.target || this.today;
    this.maxDate = this.today;

    this.downloadFileName = 'active_power.csv';
    this.isOverStackLimit = false;

    this.chartConfig = chartConfig(this);
  }

  $onInit() {
    this.updateGraph();

    this.timer = this.interval(() => {
      this.changeDate();
    }, 300000);
  }

  updateGraph() {
    this.GroupActivePowerService.show(
      angular.extend({id: this.id}, this.DateUtil.getActivePowerQueries(this.targetDate)),
      response => {
        [this.seriesList, this.sumSeriesList] = this.formatGroupActivePower(response.powers);

        if (this.isOverStackLimit) {
          this.chartConfig.series = this.sumSeriesList;
        } else {
          this.chartConfig.series = this.seriesList;
        }

        this.sumSeries = this.sumSeriesList[0];

        this.csvData = this.CsvUtil.processGroupActivePower(this.seriesList, this.categories, this.targetDate);
        this.downloadFileName = this.moment(this.targetDate).format('[group_active_power_]YYYY-MM-DD[.csv]');
      }
    )
  }

  formatGroupActivePower(groupActivePowers) {
    if (groupActivePowers.length <= 1) {
      return [[], []];
    }
    /* DB 負荷を抑えながら積み上げグラフを実現するため、サーバーからは以下の形式でデータが届く。
    groupActivePowers: [
        {
            measured_at: '2017-01-01T00:00:00+09:00',
            powers: [ // powers の長さは時間によって不定
                { sa_config_id: 1, pms_service_code: 'tds0000001', value: 100 },
                { sa_config_id: 2, pms_service_code: 'tds0000002', value: 100 },
                { sa_config_id: 3, pms_service_code: 'tds0000003', value: 100 }
            ]
        },
        {
            measured_at: '2017-01-01T00:00:30+09:00',
            ...
        },
        ...
    ]
    これをグラフに表示できる下記の形式に変換する。
    seriesList: [
        { id: 1, name: 'tds0000001', data: [100, 100, 100] }, // data は前の時間との差分値
        { id: 2, name: 'tds0000002', data: [100, 100, 100] },
        { id: 3, name: 'tds0000003', data: [100, 100, 100] }
    ]*/

    const STACK_LIMIT = 10;
    this.isOverStackLimit = false;

    // 1. 先頭データの時刻と 00:00 を比較してデータの抜け数を計算
    let firstMeasuredAt = this.moment(groupActivePowers[0].measured_at);
    let beginningTime = this.moment(this.targetDate).startOf('day');
    let shift_range = firstMeasuredAt.diff(beginningTime, 'minutes') / 30;

    // 2. data が空な初期状態の series を作る
    let seriesList = this.GroupReportUtil.createSeriesList(groupActivePowers, shift_range);

    if (seriesList.length > STACK_LIMIT) {
      this.isOverStackLimit = true;
    }

    // 3. 各 series の data に値を入れていく
    let [stackSeriesList,] = this.GroupReportUtil.createStackSeries(seriesList, groupActivePowers);

    // 4. 各配列を差分配列にする
    stackSeriesList = this.GroupReportUtil.createDiffArray(stackSeriesList);

    // 5. 差分配列の場合合計値を算出し直す。
    // 積算データで合計値算出 -> 差分 をするとデータが抜けた際にマイナスになってしまうため。
    let sumSeries = this.GroupReportUtil.createSumSeries(stackSeriesList);

    return [stackSeriesList, [sumSeries]];
  }

  changeDate(diff) {
    if (diff !== undefined) {
      this.targetDate = this.DateUtil.leapDate(this.targetDate, diff);
    }

    this.updateGraph();
  }

  $onDestroy() {
    if (this.timer) {
      this.interval.cancel(this.timer);
    }
  }
}

export default angular.module('leptonApp.dailyGroupReport', [uiRouter, GroupActivePowerService, Chart, DateUtil, CsvUtil, moment, MathUtil, GroupReportUtil])
  .config(routing)
  .component('dailyGroupReport', {
    require: {parentComponent: '^groupReportShow'},
    template: require('./daily_group_report.html'),
    controller: DailyGroupReportController
  })
  .name;



// WEBPACK FOOTER //
// ./public/dev/app/group_report/daily/daily_group_report.component.js